var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSoundOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.204 6.04368C14.0254 5.96332 13.8147 5.99546 13.6674 6.12672L11.7246 7.85353C10.1667 9.23748 8.16141 9.99999 6.07758 9.99999C4.93121 9.99999 4 10.9321 4 12.0777V15.9215C4 17.068 4.9321 17.9992 6.07758 17.9992C8.1623 17.9992 10.1676 18.7617 11.7246 20.1466L13.6674 21.8734C13.8103 22.0011 14.0183 22.0386 14.204 21.9564C14.3843 21.8761 14.4986 21.6975 14.4986 21.5002V6.49994C14.4986 6.30261 14.3843 6.12404 14.204 6.04368Z",
    fill: "#857AC8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.8145,
    y: 10.1523,
    width: 10.4491,
    height: 0.803774,
    rx: 0.401887,
    transform: "rotate(45 17.8145 10.1523)",
    fill: "#857AC8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8145,
    y: 10.1523,
    width: 10.4491,
    height: 0.803774,
    rx: 0.401887,
    transform: "rotate(45 17.8145 10.1523)",
    fill: "#857AC8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0098,
    y: 17.3906,
    width: 10.4491,
    height: 0.803774,
    rx: 0.401887,
    transform: "rotate(-45 17.0098 17.3906)",
    fill: "#857AC8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0098,
    y: 17.3906,
    width: 10.4491,
    height: 0.803774,
    rx: 0.401887,
    transform: "rotate(-45 17.0098 17.3906)",
    fill: "#857AC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSoundOff);
export default __webpack_public_path__ + "static/media/ic-sound-off.59fc7b093071f88053148e6258fdcd6f.svg";
export { ForwardRef as ReactComponent };